<template>
    <div class="text-wrapper" v-html="response">
    </div>
</template>

<script>
    export default {
        name: 'v-intro-text',
        data(){
            return {
                'response': '<i class="fa fa-spinner fa-spin"></i>',
            };
        },
        mounted(){
            const ctx = this;
            this.axios.get(`/render/intro`)
            .then(function(response){
                //Success
                ctx.response = response.data.description;
            })
            .catch(function(error) {
                alert(`unable to load page: ${error}`);
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .text-wrapper{
        h1{
            font-size:1.25em;
        }
        img{
            max-width:100%;
            margin:0 auto;
        }
        .img-center{
            text-align:center;
        }
        .warning-text{
            text-align:center;
            font-size:1.4em;
            .red{
                color:#f90202;
            }
        }
        font-size:1.15em;
        .red-text {
            color:#f90202;
        }
        .underline{
            text-decoration: underline;
        }
        .programme {
            width: 100%;
            border-collapse: collapse;
            .small {
                width: 150px;
            }
        }
        .programme th, .programme td{
            border: 1px solid #727272;
            border-collapse: collapse;
            padding: 4px
        }
    }
</style>
